import type { ProductPrices } from 'bundles/ownable-products-common/hooks/useGetProductPrices';
import type { MonetaryAmountFragment } from 'bundles/payments-common/api/__generated__/QueryCourseraTierProductConfigurations';

/**
 *  Converts a ProductPrices object to a MonetaryAmount object
 *  Specifically for Coursera Plus subscription pricing flows
 *
 * @param productPrice
 * @returns MonetaryAmount
 */
export const productPriceToMonetaryAmount = (productPrice?: ProductPrices) => {
  return {
    value: String(productPrice?.amount),
    currencyCode: productPrice?.currencyCode as MonetaryAmountFragment['currencyCode'],
  };
};
